import { render } from "./site-footer.vue?vue&type=template&id=0fb54a0e"
import script from "./site-footer.vue?vue&type=script&lang=js"
export * from "./site-footer.vue?vue&type=script&lang=js"

import "./site-footer.vue?vue&type=style&index=0&id=0fb54a0e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__